<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://boom.ink"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            ItalMotori
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }}, sviluppato con amore 
        <i class="tim-icons icon-heart-2"></i> da
        <a href="https://boom.ink" target="_blank">Boom.ink</a>.
        Per dare soddisfazioni.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
